import type { TranslationTree } from '../../types';

export const referenceAliases: TranslationTree = {
  referenceAliases: {
    tabs: {
      title: 'Reference Aliases',
    },
    displayMode: {
      title: 'Display mode',
      reference: 'Reference',
      alias: 'Alias',
      save: 'Save',
    },
    table: {
      reference: 'Reference',
      alias: 'Alias',
      actions: 'Actions',
      empty: 'No aliases defined yet.',
      loading: 'Loading...',
    },
    form: {
      add: 'Add alias',
      edit: 'Edit alias',
      delete: 'Delete alias',
      referencePlaceholder: 'Select a reference',
      aliasPlaceholder: 'e.g. Insert-Alu-6mm',
      save: 'Save',
      cancel: 'Cancel',
    },
    errors: {
      duplicateAlias: 'This alias is already used for another reference.',
      emptyFields: 'Reference and alias are required.',
      noCompany: 'Please select a company first.',
      default: 'An error occurred.',
    },
    companyPicker: {
      label: 'Company',
      placeholder: 'Select a company…',
      prompt: 'Select a company to manage its reference aliases.',
    },
    helperText: 'Known alias for this reference: {{alias}}',
  },
};
